import { convertToSubcriberDate } from "../../utils/helper";
import { SignatureDisplay } from "./signatureDisplay";

export const ChildAndCPComponent = ({
  recallDetails,
  issueDetails,
  signatures = [],
  isLoadingSignatures = false,
  onImageError,
  imageErrors = {},
  formatDate
}) => {
  return (
    <>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            backgroundColor: "#D5E4F0",
            borderRadius: "10px",
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            marginTop: "10px"
          }}>
          <h3 className="recall-summary">{recallDetails?.Title}</h3>
          <div style={{ display: "flex", flexWrap: "nowrap" }}>
            <div className="col-sm-2">
              <div className="recall-details-card-item">
                <span>{recallDetails?.id || recallDetails?.RecallId}</span>
                <span> Recall ID </span>
              </div>
            </div>
            <div className="col-sm-2">
              <div className="recall-details-card-item">
                <span>
                  {recallDetails?.RecallDate
                    ? convertToSubcriberDate(recallDetails.RecallDate)
                    : recallDetails?.created_on
                      ? convertToSubcriberDate(recallDetails.created_on)
                      : 'Date not available'}
                </span>
                <span>Recall Date</span>
              </div>
            </div>
          </div>
        </div>
        {issueDetails?.description && (
          <div className="recall-details-body-item">
            <h2>Issue Description</h2>
            <p>{issueDetails.description}</p>
          </div>
        )}
      </div>

      {/* Issue Attachment */}
      {(() => {
        const attachment = issueDetails?.attachment;

        if (!attachment) {
          return null;
        }

        const parsedAttachment = JSON.parse(attachment);
        const isAttachment = parsedAttachment?.length > 0;
        if (!isAttachment) {
          return null;
        }
        const attachmentUrl = parsedAttachment[0]?.url;
        const attachmentName = parsedAttachment[0]?.filename;
        return (
          <div className="recall-details-body-item">
            <h2>Attachment</h2>
            <span style={{ display: "flex", alignItems: "center" }}>
              <span>{attachmentName || "Attachment"}
                <a
                  href={attachmentUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    textDecoration: "none",
                    paddingLeft: "10px"
                  }}>
                  <i className="fa fa-download"></i>
                </a>
              </span>
            </span>
          </div>
        );
      })()}

      {/* Signatures Section */}
      <div className="recall-details-body-item">
        <h2>Signature</h2>
        <SignatureDisplay
          signatures={signatures}
          isLoading={isLoadingSignatures}
          onImageError={onImageError}
          imageErrors={imageErrors}
          formatDate={formatDate}
        />
      </div>
    </>
  );
};
